<template>
<div class='show-view'>
  <convert-step v-if="step === 'convert'" />
  <setting-step v-if="step === 'complete'" />
  <error-step v-if="step === 'error'" />
</div>
</template>

<script>
import ConvertStep from './convert/'
import SettingStep from './setting/'
import ErrorStep from './error/'

export default {
  components: {
    'convert-step': ConvertStep,
    'setting-step': SettingStep,
    'error-step': ErrorStep
  },
  computed: {
    project() {
      return this.$store.state.project.items[this.$route.params.id]
    },
    step() {
      if (!this.project) {
        return 'loading'
      }

      switch (this.project.state) {
        case 'uploading':
        case 'converting':
        case 'rendering':
        case 'disting':
        case 'finishing':
        case 'redisting':
          return 'convert'
        case 'halted':
          return 'error'
        case 'completed':
          return 'complete'
        default:
          return 'loading'
      }
    }
  },
  methods: {
    checkState() {
      let vm = this
      vm.$store.dispatch('project/checkState', vm.project.id)
    }
  },
  watch: {
    step: function(newValue) {
      if (newValue === 'convert') {
        this.checkState()
      }
    }
  },
  mounted() {
    if (this.step === 'convert') {
      this.checkState()
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // check wx connection
      vm.$store.dispatch('user/wxConnection')
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('project/cancelCheckState', this.project.id).then(_ => {
      next(true)
    })
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?3dd5ea17